import type { WorkAspect, WorkKind } from "../types/work";

/** Reads the playback shape from the source film's own pixel dimensions. */
export function aspectFromSize(width?: number, height?: number): WorkAspect | null {
  if (!width || !height) return null;
  const ratio = width / height;
  if (ratio > 1.15) return "landscape";
  if (ratio < 0.87) return "portrait";
  return "square";
}

export function kindFromAspect(aspect: WorkAspect): WorkKind {
  return aspect === "portrait" ? "REEL" : "FILM";
}

export const aspectLabels: Record<WorkAspect, string> = {
  landscape: "16:9 · Landscape",
  portrait: "9:16 · Vertical",
  square: "1:1 · Square",
};

export const aspectBadges: Record<WorkAspect, string> = {
  landscape: "16:9",
  portrait: "9:16",
  square: "1:1",
};

/** Card media panel ratio. */
export const aspectFrames: Record<WorkAspect, string> = {
  landscape: "aspect-video",
  portrait: "aspect-[9/16]",
  square: "aspect-square",
};

/** Viewer dialog frame. */
export const viewerFrames: Record<WorkAspect, string> = {
  landscape: "aspect-video max-h-[76svh] w-full max-w-[1500px]",
  portrait: "aspect-[9/16] max-h-[76svh]",
  square: "aspect-square max-h-[76svh]",
};
